import API from "./baseApi";

const getSubCategories = (payload) => {
  return API.get("/services/subCategories/get", payload);
};
const updateSubCategoryType = (payload) => {
  return API.post("/services/subcategories/updateType", payload);
};
const deleteSubCatergoryMapping = (payload) => {
  return API.post(`/services/subcategories/deleteSubCategoryMapping`,payload);
};
export default {
  getSubCategories,
  updateSubCategoryType,deleteSubCatergoryMapping
};
